module.exports = __webpack_public_path__ + "static/media/grayCloseX.9be8546a.svg";